<template>
    <canvas id="bookings-chart" width="90%" height="40%"></canvas>
</template>

<script>
    export default {
        props: ['occupancy'],
        name: "admin-dash-bookings-graph",
        watch: {
            occupancy: function () {
                this.drawChart();
            }
        },
        methods: {
            getGraphData: function () {
                let occupied = [];
                let unoccupied = [];
                let graphDataArray = [];

                this.occupancy.forEach(function (element) {
                    let tempBookings = element.bookings;
                    let tempSchedules = element.schedules;
                    let tempUnoccupied = tempSchedules - tempBookings;
                    let tempDate = new Date(element.date);

                    unoccupied.push({
                        y: tempUnoccupied,
                        x: tempDate
                    });
                    occupied.push({
                        y: tempBookings,
                        x: tempDate
                    });
                });

                let datasets = [];

                datasets.push({
                    label: 'Antal bokade pass',
                    data: occupied,
                    backgroundColor: 'rgba(255, 0, 0, 0.3)',
                });

                datasets.push({
                    label: 'Antal lediga pass',
                    data: unoccupied,
                    backgroundColor: 'rgba(0, 255, 0, 0.3)',
                });

                return datasets;
            },
            getGraphLabels: function () {
                let labelArray = [];
                this.occupancy.forEach(function (element) {
                    let tempDate = new Date(element.date);
                    labelArray.push(tempDate);
                });
            },
            drawChart: function () {
                let graphElement = $("#bookings-chart");
                let options = {
                    tooltips: {
                        mode: 'index',
                        callbacks: {
                            title: function (tooltipItem, chart) {

                                let returnString = new Date(tooltipItem[0].xLabel).toLocaleDateString(window.navigator.language, {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    });
                                return returnString;
                            }
                        }
                    },
                    responsive: true,
                    scales: {
                        yAxes: [{
                            id: 'A',
                            ticks: {
                                beginAtZero: true,
                            },
                            stacked: true
                        }],
                        xAxes: [{
                            type: 'time',
                            positive: 'bottom',
                            time: {
                                unit: 'day'
                            },
                            stacked: true
                        }]
                    }
                };

                let data = this.getGraphData();
                let labels = this.getGraphLabels();

                let occupancyChart  = new Chart(graphElement, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: data,
                    },
                    options: options
                });

            }
        }, //methods
        mounted: function () {
            this.drawChart();
        }
    }
</script>

<style scoped>

</style>
